import React, { useEffect, useRef } from 'react';
import { Highlighter } from 'lucide-react';
import gsap from 'gsap';

const AnimatedUnderline = ({
  text,
  color = '#6ca0dc', // Updated to use the primary blue color
  fontSize = '30px',
  className = '',
}) => {
  const containerRef = useRef(null);
  const highlightRef = useRef(null);
  const highlighterRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !highlightRef.current || !highlighterRef.current) return;

    const highlight = highlightRef.current;
    const highlighter = highlighterRef.current;

    gsap.set(highlight, {
      scaleX: 0,
      transformOrigin: 'left',
    });

    gsap.set(highlighter, {
      opacity: 0,
      scale: 0,
      rotation: -30,
    });

    const tl = gsap.timeline({ defaults: { ease: 'power2.inOut' } });

    tl.to(highlighter, {
      opacity: 1,
      scale: 1,
      duration: 0.3,
    })
      .to(highlight, {
        scaleX: 1,
        duration: 1.5,
      })
      .to(
        highlighter,
        {
          x: containerRef.current.offsetWidth,
          duration: 1.5,
        },
        '<'
      )
      .to(
        highlighter,
        {
          opacity: 0,
          scale: 0,
          duration: 0.3,
        },
        '>-0.3'
      );

    return () => {
      tl.kill();
    };
  }, []);

  return (
    <div 
      ref={containerRef}
      className={`relative inline-block ${className}`}
      style={{ fontSize }}
    >
      <div className="relative">
        <div 
          ref={highlightRef}
          className="absolute inset-0 -skew-y-2"
          style={{
            backgroundColor: color,
            opacity: 0.5, // Keeping the increased opacity for better visibility
            height: '100%',
            width: '100%',
          }}
        />
        <span className="relative">{text}</span>
      </div>
      <div
        ref={highlighterRef}
        className="absolute left-0 top-1/2 pointer-events-none"
        style={{ color }}
      >
        <Highlighter
          size={32}
          className="transform -translate-y-1/2"
        />
      </div>
    </div>
  );
};

export default AnimatedUnderline;
